import React, { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import "./App.scss";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import createStore from "../../store";
import LoginScreen from "../LoginScreen/LoginScreen";
import KnovoMainScreen from "../KnovoMainScreen/KnovoMainScreen";
import Notfound from "../NotFoundScreen/NotFoundScreen";
import SmartPaperScreen from "../SmartPaperScreen/SmartPaperScreen";
import SmartSlideScreen from "../SmartSlideScreen/SmartSlideScreen";
import HomeScreen from "../HomeScreen/HomeScreen";
import KnovoActivityScreen from "../KnovoActivityScreen/KnovoActivityScreen";
const { store, persistor } = createStore();

export default function App() {
  // console.log = () => {};
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Switch>
            <Redirect
              exact
              from="/"
              to="/login"
              key={window.location.pathname}
            />
            <Route
              exact
              path="/login"
              component={LoginScreen}
              key={window.location.pathname}
            />
            <Route
              exact
              path="/knovo"
              component={KnovoMainScreen}
              key={window.location.pathname}
            />
            <Route
              exact
              path="/home"
              component={HomeScreen}
              key={window.location.pathname}
            />
            <Route
              path="/Activity"
              component={KnovoActivityScreen}
              key={window.location.pathname}
            />
            <Route
              path="/SmartPaper/:id"
              component={SmartPaperScreen}
              key={window.location.pathname}
            />
            <Route
              path="/SmartSlide/:id"
              component={SmartSlideScreen}
              key={window.location.pathname}
            />
            <Route component={Notfound} />
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}
